import React from 'react';
import {
    BrowserRouter as Router,
    Route
} from 'react-router-dom';
import CesiumMap from './components/CesiumMap/CesiumMap';

const App = () => {
  
    return (
        // <Layout>
        <Router>
            <Route path="/:id">
                <CesiumMap />
            </Route>
            <Route exact path="/">
                  No map found.
            </Route>
        </Router>
        // </Layout>
    );
};


export default App;
